import axios from 'axios';

const instance = axios.create({
    baseURL: 'https://backie.retroalimentame.com.mx'
    //baseURL: 'http://192.168.1.66:9816'
});

export default instance;
